import React from 'react'
import StoryPlayer from './story-player'
import './App.css'

const convertArrayToObject = (array, key='id') => {
  const initialValue = {}
  return array.reduce((obj, item) => ({
    ...obj,
    [item[key]]: item,
  }), initialValue)
}

function App() {
  const data = window.moiki_story
  if (!data) {
    return null
  }
  const story = {
    ...data,
    sequences: convertArrayToObject(data.sequences),
    assets: convertArrayToObject(data.assets),
    sounds: convertArrayToObject(data.sounds),
    counters: convertArrayToObject(data.counters),
  }
  return (
    <StoryPlayer story={story} showMenu={true} />
  )
}

export default App 
